
export function readUTF8TextFile(file) {
    var decoder = new TextDecoder('utf-8');
    var content = atob(file).trim();
    const length = content.length;
    const bytes = new Uint8Array(length);
    for (let i = 0; i < length; i++) {
      bytes[i] = content.charCodeAt(i);
    }

    return decoder.decode(bytes.buffer);

}